module.exports = __webpack_public_path__ + "img/choreograph.4884bc2a.svg";